export const PLAN_TYPES = [
  { value: "master", label: "Master" },
  { value: "starter", label: "Starter" },
  { value: "ultimate", label: "Ultimate" }
];
